'use client';
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';

export default function LandingHero() {
  const router = useRouter();
  const [pressed, setPressed] = useState(false);

  function handleBuild() {
    setPressed(true);
    setTimeout(() => {
      router?.push('/build-your-smoo-order-flow');
    }, 150);
  }

  return (
    <main className="relative min-h-screen w-full overflow-hidden">
      {/* Full-screen blurred background image */}
      <div className="absolute inset-0 z-0">
        <Image
          src="/assets/images/file_00000000102071f4aa6e0bfa769a2d93-1786991635517.jpg"
          alt="SMOO smoothie background"
          fill
          priority
          className="object-cover object-center"
          sizes="100vw"
        />
        {/* Blur overlay */}
        <div className="absolute inset-0" style={{ backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', backgroundColor: 'rgba(0,0,0,0.35)' }} />
      </div>

      {/* EMPLOYEE LOGIN — top-right corner, clearly labelled, non-intrusive */}
      <div className="absolute top-4 right-4 z-20">
        <button
          onClick={() => router?.push('/staff/login')}
          className="font-display text-xs tracking-widest px-3 py-2 transition-opacity duration-150 hover:opacity-80"
          style={{
            backgroundColor: 'rgba(26,10,10,0.75)',
            color: '#F28C18',
            border: '1px solid rgba(242,140,24,0.5)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
          }}
        >
          EMPLOYEE LOGIN
        </button>
      </div>

      {/* Content overlay */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-10">
        {/* Logo — full width of screen */}
        <div className="w-full flex justify-center mb-8">
          <Image
            src="/assets/images/IMG-20260611-WA0023_1_-1786991473569.png"
            alt="SMOO Logo"
            width={1200}
            height={400}
            priority
            className="w-full max-w-full object-contain"
            style={{ maxHeight: '35vh' }}
          />
        </div>

        {/* Headline */}
        <h1 className="font-display text-center leading-none mb-4 text-white"
          style={{ fontSize: 'clamp(3rem, 12vw, 8rem)', letterSpacing: '0.05em', textShadow: '3px 3px 0px rgba(229,43,95,0.8)' }}>
          BUILD YOUR SMOO
        </h1>

        {/* Tagline */}
        <p className="text-center text-white font-medium mb-10 opacity-90"
          style={{ fontSize: 'clamp(1rem, 3vw, 1.25rem)' }}>
          Pick your vibe. Pick your Smoo. Make it yours.
        </p>

        {/* Primary CTA */}
        <button
          onClick={handleBuild}
          className={`
            diner-border diner-shadow btn-press
            bg-primary text-primary-foreground
            font-display tracking-widest
            px-12 py-5
            transition-all duration-150
            hover:bg-burgundy hover:border-burgundy
            ${pressed ? 'scale-95 opacity-80' : ''}
          `}
          style={{ fontSize: 'clamp(1rem, 3vw, 1.5rem)', letterSpacing: '0.15em' }}>
          BUILD YOUR SMOO
        </button>

        {/* Sub copy */}
        <p className="mt-5 text-sm text-white opacity-70 tracking-wide">
          Delivery &amp; Collection · Harare
        </p>

        {/* Range colour dots */}
        <div className="flex items-center gap-2 mt-8">
          {[
            { color: '#F5C518', label: 'Power' },
            { color: '#0EA5A0', label: 'Hydro' },
            { color: '#F28C18', label: 'Shield' },
            { color: '#7B2D8B', label: 'Glow-Up' },
            { color: '#2D5A27', label: 'Moves' },
            { color: '#6B3F1F', label: "Buzzin'" },
          ]?.map((range) => (
            <div
              key={`range-dot-${range?.label}`}
              title={range?.label}
              className="w-4 h-4 rounded-full diner-border"
              style={{ backgroundColor: range?.color }}
            />
          ))}
          <span className="text-xs text-white opacity-70 ml-1 font-medium">
            6 ranges. 20 Smoos.
          </span>
        </div>
      </div>
    </main>
  );
}